/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module Me
 */

const ROUTE = '/me';

function index() {
    return window.tenantAxios.get(ROUTE);
}

function setActiveTenant(tenantId) {
    return window.centralAxios.patch(ROUTE, {
        tenant_id: tenantId,
    });
}

// Helper API Services

export default {
    index,
    setActiveTenant,
};
